import React from 'react';
import logo from '../../Asset/Cakerestrologo.png';
import './LogoLoader.css';

const LogoLoader = () => {
    return (
        <div className="logo-loader-container">
            <div className="logo-loader-content">
                <img src={logo} alt="Loading..." className="loader-logo-img" />
                <div className="loader-pulse"></div>
            </div>
        </div>
    );
};

export default LogoLoader;
